<template>
  <div class="flex gap-4 items-start w-full relative">
    <span class="absolute left-6 -top-1 md:relative md:top-auto md:left-auto w-10 shrink-0 aspect-square rounded-full bg-lilac-pale text-deep-indigo-dark flex items-center justify-center">
      <Icon id="logo" class="text-xl"/>
    </span>
    <div :class="['p-6 md:p-8 mt-4 md:mt-0 pt-7 md:pt-8 border border-lilac-medium rounded-lg grow', {'max-w-[1000px]': limit}]">
      <slot/>
    </div>
  </div>
</template>

<script>
import {Icon} from '@/components/helpers'

export default {
  name: 'ContentBox',
  components: {Icon},
  props: {
    limit: {
      type: Boolean,
      default: false
    }
  }
}
</script>